/* global swal */
import './style.less';

export default function($scope, $state, $log, $stateParams, ApiClass) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;

  vm.profile_uid = $stateParams.id;

  vm.uploadedProductImage = link => {
    vm.ngModel.productImageUrl = link;
  };

  vm.submit = function({ name, description, author, productImageUrl, sendEmail, tags }) {
    vm.loading = false;

    if (!name) return swal('Hold Up!', 'Please add a name for the learning track.', 'info');
    if (!author) return swal('Hold Up!', 'Please add a author for the learning track.', 'info');
    if (!description) return swal('Hold Up!', 'Please add a description for the learning track.', 'info');

    ApiClass.learningsPut(
      {},
      { name, description, author, productImageUrl, sendEmail, tags },
      { queryParams: { manage: true } }
    )
      .then(({ data: { track } }) =>
        $state.go('app.admin.learning.track.edit', { id: vm.profile_uid, track_id: track.track_id })
      )
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    $log.debug('Learning Track Create Controller Loaded');
    vm.formData = {
      courses: []
    };
    vm.loaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/learningTracks/create/controller.js